// extracted by mini-css-extract-plugin
export default {"EditNamePage":"styles_EditNamePage__ix6nj","fullWidth":"styles_fullWidth__OIkQQ"};